import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { historyTabs } from "./constants.js";
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse,
    config = _ref.config;
  return {
    getReservationHistory: function () {
      var _getReservationHistory = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref2,
          tab,
          start,
          limit,
          driverName,
          registrationNumber,
          response,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, tab = _ref2.tab, start = _ref2.start, limit = _ref2.limit, driverName = _ref2.driverName, registrationNumber = _ref2.registrationNumber;
              _context.next = 3;
              return amsResponse.getRawBody({
                method: "GET",
                path: "v1.2/rentcontract/bookinghistory",
                query: {
                  requestMode: _defineProperty(_defineProperty({}, historyTabs.ACTIVE, "presence"), historyTabs.PAST, "history")[tab],
                  start: start,
                  limit: limit,
                  drivername: driverName,
                  registrationNumber: registrationNumber
                }
              });
            case 3:
              response = _context.sent;
              return _context.abrupt("return", {
                totalCount: response.totalCount,
                data: response.data || []
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getReservationHistory() {
        return _getReservationHistory.apply(this, arguments);
      }
      return getReservationHistory;
    }()
  };
};